import  api  from './api';

const config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': false
    }
}

export const getAreas = async () => {
    let areas = null;
    try {
        const response = await api.get(`Empresa/listareas`, config);
        areas = response.data.data;
    } catch (err) {}
    return areas;
}

export const getAreasPI = async () => {
    let areas = null;
    try {
        const response = await api.get(`Empresa/listareaspi`, config);
        areas = response.data.data;
    } catch (err) {}
    return areas;
}
